import { cn } from '@/lib/utils'

const StatCell = ({ label, value, footer, footerTrailing, children, className }) => (
    <div
        className={cn(
            'tw:flex tw:flex-col tw:justify-between tw:gap-2 tw:bg-[#071727] tw:rounded-2xl tw:px-5 tw:py-3.5 tw:min-h-[112px]',
            className,
        )}
    >
        <div className="tw:flex tw:flex-col tw:gap-2 tw:min-h-0">
            <span className="tw:text-sm tw:text-[#899CBD]">{label}</span>
            <span className="tw:text-[22px] tw:leading-tight tw:font-semibold tw:text-white">{value}</span>
            {footer &&
                (footerTrailing ? (
                    <div className="tw:flex tw:items-center tw:justify-between tw:gap-2 tw:w-full tw:min-w-0">
                        <span className="tw:text-sm tw:text-[#899CBD] tw:min-w-0">{footer}</span>
                        <div className="tw:shrink-0">{footerTrailing}</div>
                    </div>
                ) : (
                    <span className="tw:text-sm tw:text-[#899CBD]">{footer}</span>
                ))}
        </div>
        {children}
    </div>
)

export default StatCell
